import React, { useState } from 'react';
import Loader from 'components/Loader';
import { ModalAccountReportSubscription } from 'components/ModalAccountReportSubscription';
import Button from 'components/ui-kits/Button';
import UnsubscribePlanDialog from 'components/UnsubscribePlanDialog/UnsubscribePlanDialog';
import { PLAN_NAME } from 'const/Const';
import { format, parseISO } from 'date-fns';
import { useMutation, useQueryClient } from 'react-query';
import { unsubscribeMerchantPlan } from 'services/merchantService';
import { handleError, handleSuccess } from 'utils';
import { SubscriptionPlanDetail } from 'types/Merchant';

type ActionButtonProps = {
  planType?: keyof typeof PLAN_NAME;
  isAccountingReport?: boolean;
  currentPlan: SubscriptionPlanDetail | undefined;
  showUnsubButton?: boolean;
};

const ActionButton = ({
  currentPlan,
  isAccountingReport = false,
  showUnsubButton = false
}: ActionButtonProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const queryClient = useQueryClient();

  const { mutate, isLoading: isUnsubscribingPlan } = useMutation({
    mutationFn: (id: number) => unsubscribeMerchantPlan(id),
    onError: () => handleError(),
    onSuccess: () => {
      handleSuccess(
        'Vous vous êtes désabonné avec succès de la formule STANDARD.'
      );
      setShowDialog(false);
      queryClient.invalidateQueries(['getMerchantSubscriptionPlans']);
    }
  });

  const isSubscribed = !!currentPlan && !currentPlan.isCancelled;
  const isCurrentPlanCancelled = !!currentPlan?.isCancelled;
  const renewalDate = currentPlan
    ? format(parseISO(currentPlan.endDate), 'dd/MM/yyyy')
    : '';

  return (
    <>
      {isUnsubscribingPlan && <Loader />}
      {showUnsubButton && (
        <Button
          variant={'primary'}
          isFluid={false}
          isUpperCase={false}
          isDisabled={isAccountingReport || isCurrentPlanCancelled}
          fontWeight="BOLD"
          onClick={() => setShowDialog(true)}>
          Désabonnez-vous
        </Button>
      )}
      {showDialog && isSubscribed && (
        <UnsubscribePlanDialog
          onClose={() => setShowDialog(false)}
          onConfirm={() => {
            if (currentPlan) {
              mutate(currentPlan.id);
            }
          }}
          renewalDate={renewalDate}
        />
      )}
      {showDialog && !isSubscribed && (
        <ModalAccountReportSubscription
          onClose={() => setShowDialog(false)}
          showOverlay
        />
      )}
    </>
  );
};

export default ActionButton;
